<template>
    <div class="card-container" v-once>
        <picture>
            <source srcset="/images/events/2025/oct-used-cars/fake-card-fg-top@2x.webp" type="image/webp">
            <img class="img-responsive card-container__img  card-container__img--top" srcset="/images/events/2025/oct-used-cars/fake-card-fg-top@2x.png" alt="">
        </picture>
        <picture>
            <source srcset="/images/events/2025/oct-used-cars/fake-card-middle@2x.webp" type="image/webp">
            <img class="img-responsive card-container__img card-container__img--middle" srcset="/images/events/2025/oct-used-cars/fake-card-middle@2x.png" alt="">
        </picture>
        <picture>
            <source srcset="/images/events/2025/oct-used-cars/fake-card-bottom@2x.webp?v=1" type="image/webp">
            <img class="img-responsive card-container__img  card-container__img--bottom" srcset="/images/events/2025/oct-used-cars/fake-card-bottom@2x.png?v=1" alt="">
        </picture>
    </div>
</template>

<script>
export default {};
</script>

<style lang="scss">
.card-container {
    box-shadow: 0 11px 24px rgba(0, 0, 0, 0.15);
    border-radius: 10px;
    width: 100%;
    height: 100%;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    padding: 0 15px 15px 15px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;

    @media (min-width: 768px) {
        padding-bottom: 40px;
    }

    .no-webp & {
        background-image: url('/images/events/2025/oct-used-cars/fake-card-bg@1x.jpg');
    }

    .webp & {
        background-image: url('/images/events/2025/oct-used-cars/fake-card-bg@1x.webp');
    }

    @media only screen and (-webkit-min-device-pixel-ratio: 2), only screen and (min--moz-device-pixel-ratio: 2), only screen and (min-device-pixel-ratio: 2), only screen and (min-resolution: 192dpi), only screen and (min-resolution: 2dppx) {
        .no-webp & {
            background-image: url("/images/events/2025/oct-used-cars/fake-card-bg@2x.jpg");
        }
        .webp & {
            background-image: url("/images/events/2025/oct-used-cars/fake-card-bg@2x.webp");
        }
    }

    &__img {
        display: block;
        margin: 0 auto;
        position: relative;

        &--top {
            z-index: 4;
        }
        &--middle {
            z-index: 2;
            transform: translateY(-10px);

            @media (min-width: 768px) {
                transform: translateY(-30px);
            }
        }
        &--bottom {
            z-index: 3;
            transform: translateY(-10px);

            @media (min-width: 768px) {
                transform: translateY(-30px);
            }
        }
    }

}
</style>



// WEBPACK FOOTER //
// resources/assets/js/used-vue/components/Campaign/2025/October/FakeCard.vue